if (!customElements.get('vega-collection-image')) {
    class ImageSwiper extends HTMLElement {
        /**
         * Section settings (only part)
         */
        sectionSettings;

        /**
         * Swiper entity
         * 
         * @type {Swiper}
         */
        mySwiper;

        constructor() {
            super();
            this.sectionSettings = JSON.parse(this.getAttribute("data-settings").replaceAll("/'", '"'));
        }

        connectedCallback() {
            this.mySwiper = new Swiper(this.querySelector(`.image_swiper_container`), {
                loop: false,
                spaceBetween: 0,
                slidesPerView: 1,
                centeredSlides: false,
                observer: true,
                resizeObserver: true,
                navigation: {
                    nextEl: this.querySelector(`.swiper-btn-next`),
                    prevEl: this.querySelector(`.swiper-btn-prev`),
                },
                pagination: {
                    el: this.querySelector(`#${this.id} .swiper-pagination`),
                    clickable: true,
                },
                on: {
                    slideChange: this.handleSlideChange.bind(this),
                },
                scrollbar: {
                    el: this.querySelector(`#${this.id} .swiper-scrollbar`),
                },
                breakpoints: {
                    1280: {
                        slidesPerView: this.sectionSettings.image_columns_pc,
                        spaceBetween: 40,
                    },
                    768: {
                        slidesPerView: this.sectionSettings.image_columns_pad,
                        spaceBetween: 30,
                    },
                    375: {
                        slidesPerView: this.sectionSettings.image_columns_mb,
                        spaceBetween: 15,
                    },
                },
            });
            this.initEvent();
        }

        /**
         * 轮播图切换事件
         */
        handleSlideChange(swiper) {
        }

        initEvent() {
        }
    }

    customElements.define('vega-collection-image', ImageSwiper);
}

